import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { AvailableTabProperties } from '../../interface/station-management-side-panel.interface';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setSelectedStation } from '../../redux/slices/StationManagementSidePanelSlice';

import StationComparison from './components/StationComparison';
import StationDashboard from './components/StationDashboard';
import StationManagementTabs from './components/StationManagementTabs';
import StationPerformance from './components/StationPerformance';
import StationReports from './components/StationReports';
import StationTickets from './components/StationTickets';

/**
 *  Station Management
 * @returns
 */
function StationManagementSidePanel() {
  const { i18n } = useTranslation('sidePanel');
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { tab: deviceTab } = useParams<{ tab: string }>();
  const { selectedChargingPoint } = useAppSelector((state) => state.stationManagement);
  const { id } = useParams();
  const [searchParameters] = useSearchParams();
  const { currentPage } = useParams<{ currentPage: string }>();

  const searchBy = searchParameters.get('searchBy'); // "New station"
  const { type } = useParams<{ type: string }>();
  const { userCustomId } = useParams<{ userCustomId: string }>();
  const [containerTabs, setContainerTabs] = useState<AvailableTabProperties[]>([
    {
      label: 'station-dashboard',
      key: 'station-dashboard',
      isActive: false,
    },
    {
      label: 'station-performance',
      key: 'station-performance',
      isActive: false,
    },
    {
      label: 'reports',
      key: 'reports',
      isActive: false,
    },
    {
      label: 'station-comparison',
      key: 'station-comparison',
      isActive: false,
    },
    // {
    //   label: 'Tickets',
    //   key: 'tickets',
    //   isActive: false,
    // },
  ]);

  /**
   * Function to switch the tab
   * @param {string} key
   */
  const handleSwitchTab = (key: string, navigateRequire: boolean = true) => {
    const moduleName = location.pathname.split('/')[2];

    setContainerTabs((previousTabs: AvailableTabProperties[]) =>
      previousTabs.map((tab) => {
        if (tab.key === key) {
          if (navigateRequire)
            if (moduleName === 'charging-station') {
              navigate({
                pathname: `/ev-admin/${moduleName}/${currentPage}/station/${selectedChargingPoint?.id}/${tab.key}`,
                search: `?searchBy=${selectedChargingPoint?.name}`,
              });
            } else if (type && userCustomId) {
              navigate({
                pathname: `/ev-admin/end-consumer/${type}/profile/${userCustomId}/station/${selectedChargingPoint?.id}/${tab.key}`,
                search: `?searchBy=${selectedChargingPoint?.name}`,
              });
            } else {
              navigate({
                pathname: `/ev-admin/${moduleName}/station/${selectedChargingPoint?.id}/${tab.key}`,
                search: `?searchBy=${selectedChargingPoint?.name}`,
              });
            }

          return {
            ...tab,
            isActive: true,
          };
        }
        return {
          ...tab,
          isActive: false,
        };
      }),
    );
  };

  useEffect(() => {
    handleSwitchTab(deviceTab || 'station-dashboard', false);
  }, [deviceTab]);

  useEffect(() => {
    if (!id) return;
    if (selectedChargingPoint?.id === id) return;
    dispatch(
      setSelectedStation({
        id,
        name: searchBy,
      }),
    );
  }, [id]);

  return (
    <div className="station-management-side-panel-wrap" dir={i18n.dir()}>
      <div className="station-management-container">
        <StationManagementTabs containerTabs={containerTabs} handleSwitchTab={handleSwitchTab} />
        <div className="station-management-content">
          {(() => {
            const activeTab = containerTabs.find((tab) => tab.isActive)?.key || 'device-details';

            let deviceContent = null;
            switch (activeTab) {
              case 'station-dashboard':
                deviceContent = <StationDashboard />;
                break;
              case 'station-performance':
                deviceContent = <StationPerformance />;
                break;
              case 'reports':
                deviceContent = <StationReports />;
                break;
              case 'station-comparison':
                deviceContent = <StationComparison />;
                break;
              case 'tickets':
                deviceContent = <StationTickets />;
                break;
              default:
                deviceContent = <StationDashboard />;
                break;
            }
            return deviceContent;
          })()}
        </div>
      </div>
    </div>
  );
}

export default StationManagementSidePanel;
